import React, { useEffect, useMemo, useState } from 'react';
import { NavbarSlotContext } from '../../context/NavbarSlotContext';
import SignIn from '../../pages/ExtraPages/SignIn';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setEmailRedux,
  setLoginAgencyID,
  setPasswordRedux,
  setUserAppNotifications,
  setUserDetailsObj,
  setUserRolePermissionsArr,
  setUserToken
} from '../../Redux/UserSlice';
import {
  AppBar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { setRateValues } from '../../Redux/GetRatesSlice';
import {
  setQuickQuoteRateValues,
  setQuickQuoteTLRateValues
} from '../../Redux/QuickQuoteRateSlice';
import {
  setQuickQuoteDeliveryCheckedRedux,
  setQuickQuotePickUpCheckedRedux
} from '../../Redux/QuickQuoteSwevicesSlice';
import {
  setClassWeight,
  setDimensionsWeight
} from '../../Redux/QuickQuoteTotalWeightSlice';
import { GetAppNotifications, AagencyLogout } from '../../apis/Agency';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { base_logo_url } from '../../apis/constants';
import { formatNotificationTime, sanitizeHTML } from '../../apis/Utils';
import NotificationCard from '../../pages/Notifications/NotificationCard';
import NotificationDialog from '../../pages/Notifications/NotificationDialog';

// MUI Icons
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import TimelineIcon from '@mui/icons-material/Timeline';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { RequestQuoteRounded } from '@mui/icons-material';
import TrackShipmentModule from '../../pages/TrackShipment/TrackShipmentModule';

// ─── Layout constants ─────────────────────────────────────────────────────────
const DRAWER_WIDTH = 220;
const COLLAPSED_WIDTH = 76;

// ─── Full logo: icon + "ShipTechPro" wordmark ────────────────────────────────
const AppLogo = () => (
  <svg
    width='175'
    height='45'
    viewBox='0 0 1400 360'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <defs>
      <linearGradient
        id='appLogoGrad'
        x1='82'
        y1='72'
        x2='288'
        y2='278'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#1297FF' />
        <stop offset='1' stopColor='#006CFF' />
      </linearGradient>
    </defs>
    <g
      transform='translate(38 20) scale(.625)'
      stroke='url(#appLogoGrad)'
      strokeWidth='54'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    >
      <path d='M176 108 L256 188 L336 108' />
      <path d='M108 176 L188 256 L108 336' />
      <path d='M336 404 L256 324 L176 404' />
      <path d='M404 336 L324 256 L404 176' />
    </g>
    <text
      x='365'
      y='220'
      fill='#000000'
      fontFamily='Inter, Arial, Helvetica, sans-serif'
      fontSize='118'
      letterSpacing='-4'
    >
      <tspan fontWeight='700'>Ship</tspan><tspan fontWeight='400'>TechPro</tspan>
    </text>
  </svg>
);

// ─── Logo icon (symbol only — shown in collapsed sidebar) ────────────────────
const AppLogoIcon = () => (
  <svg
    width='32'
    height='32'
    viewBox='80 60 240 240'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <defs>
      <linearGradient
        id='appLogoIconGrad'
        x1='82'
        y1='72'
        x2='288'
        y2='278'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#1297FF' />
        <stop offset='1' stopColor='#006CFF' />
      </linearGradient>
    </defs>
    <g
      transform='translate(38 20) scale(.625)'
      stroke='url(#appLogoIconGrad)'
      strokeWidth='54'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    >
      <path d='M176 108 L256 188 L336 108' />
      <path d='M108 176 L188 256 L108 336' />
      <path d='M336 404 L256 324 L176 404' />
      <path d='M404 336 L324 256 L404 176' />
    </g>
  </svg>
);

// ─── Shipment custom icon ─────────────────────────────────────────────────────
const ShipmentIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'currentColor' }}
  >
    <path d='M6.33333 6.0625L8 5.22917L9.66667 6.0625V2.10417H6.33333V6.0625ZM3.83333 12.1042V10.4375H8V12.1042H3.83333ZM2.16667 15.4375C1.70833 15.4375 1.31583 15.2744 0.989167 14.9483C0.663055 14.6217 0.5 14.2292 0.5 13.7708V2.10417C0.5 1.64583 0.663055 1.25333 0.989167 0.926667C1.31583 0.600555 1.70833 0.4375 2.16667 0.4375H13.8333C14.2917 0.4375 14.6842 0.600555 15.0108 0.926667C15.3369 1.25333 15.5 1.64583 15.5 2.10417V13.7708C15.5 14.2292 15.3369 14.6217 15.0108 14.9483C14.6842 15.2744 14.2917 15.4375 13.8333 15.4375H2.16667ZM2.16667 13.7708H13.8333V2.10417H11.3333V8.77083L8 7.10417L4.66667 8.77083V2.10417H2.16667V13.7708Z' />
  </svg>
);

// ─── Navigation definition ────────────────────────────────────────────────────
const FULL_NAVIGATION = [
  // MAIN
  // MAIN
  { segment: 'quick-quote',     title: 'Quick Quote',      shortTitle: 'Quote',    section: 'Main',           icon: <RequestQuoteRounded /> },
  { segment: 'dashboard',       title: 'Dashboard',        shortTitle: 'Dash',     section: 'Main',           icon: <DashboardOutlinedIcon /> },
  { segment: 'carriers',        title: 'Carriers',         shortTitle: 'Carriers', section: 'Main',           icon: <LocalShippingOutlinedIcon /> },
  { segment: 'manage-shipments',title: 'Shipment',         shortTitle: 'Shipment', section: 'Main',           icon: <ShipmentIcon /> },
  // ADMINISTRATION
  { segment: 'users',           title: 'Users',            shortTitle: 'Users',    section: 'Administration', icon: <GroupOutlinedIcon /> },
  { segment: 'roles',           title: 'Roles',            shortTitle: 'Roles',    section: 'Administration', icon: <LockPersonIcon /> },
  { segment: 'view-locations',  title: 'Locations',        shortTitle: 'Locations',section: 'Administration', icon: <LocationOnOutlinedIcon /> },
  { segment: 'app-registration',title: 'App Registration', shortTitle: 'App Reg',  section: 'Administration', icon: <AccountTreeOutlinedIcon /> },
  // MONITORING
  { segment: 'Logs',            title: 'Logs',             shortTitle: 'Logs',     section: 'Monitoring',     icon: <WysiwygIcon /> },
  // SETTINGS
  { segment: 'settings',        title: 'Settings',         shortTitle: 'Settings', section: 'Settings',       icon: <SettingsIcon /> },
  { segment: 'invoice-audit',   title: 'Invoice Audit',    shortTitle: 'Invoice',  section: 'Settings',       icon: <DescriptionOutlinedIcon /> },
];

const PERMISSION_MAP = {
  'quick-quote': 'Quick',
  dashboard: 'Dashboard',
  carriers: 'Carriers',
  users: 'Users',
  roles: 'Roles',
  'manage-shipments': 'Manage-Shipments',
  'view-locations': 'Locations',
  'app-registration': 'App-Registration',
  Logs: 'Logs',
  settings: 'Settings',
  'invoice-audit': 'Invoice-Audit'
};

// Alias paths so sub-routes keep the parent nav item highlighted
const SEGMENT_ALIASES = {
  'quick-quote': ['/bookshipment', '/bookshipmentTL', '/bookshipmentParcel'],
  carriers: ['/create-carrier'],
  'manage-shipments': [
    '/dispatchshipmentLTL',
    '/dispatchshipmentTL',
    '/dispatchshipmentParcel'
  ],
  'view-locations': ['/add-locations']
};

const isActive = (segment, pathname) => {
  if (pathname === '/' + segment) return true;
  const aliases = SEGMENT_ALIASES[segment];
  return aliases ? aliases.includes(pathname) : false;
};

// ─── Toolbar: notifications + user profile ────────────────────────────────────
const ToolbarActions = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const UserDetails = useSelector(state => state.user.UserDetailsObj.userInfo);
  const AgencyAdminDetails = useSelector(
    state => state.user.AgencyAdminDetails
  );
  const UserNotificationsObj = useSelector(
    state => state.user.UserAppNotifications
  );
  const rememberMe = useSelector(state => state.userDetails.rememberMe);

  const UserNotifications = UserNotificationsObj?.notifications || [];

  const [userProfileOpen, setUserProfileOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [notifView, setNotifView] = useState({});

  const firstLetter = UserDetails?.firstName
    ? UserDetails.firstName.charAt(0).toUpperCase()
    : '';
  const lastLetter = UserDetails?.lastName
    ? UserDetails.lastName.charAt(0).toUpperCase()
    : '';

  const avatarStyle = {
    objectFit: 'cover',
    borderRadius: '8px',
    height: '36px',
    width: '36px',
    backgroundColor: 'white',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#133',
    cursor: 'pointer'
  };

  const handleLogout = () => {
    sessionStorage.setItem('FetchTrackingLoader', 'false');
    AagencyLogout().catch(() => {});
    localStorage.clear();
    !rememberMe && dispatch(setPasswordRedux(''));
    !rememberMe && dispatch(setEmailRedux(''));
    !rememberMe && dispatch(setUserDetailsObj({}));
    document.cookie =
      'userInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    dispatch(setUserToken(''));
    dispatch(setLoginAgencyID(''));
    dispatch(setUserRolePermissionsArr([]));
    dispatch(setRateValues(''));
    dispatch(setQuickQuoteTLRateValues(''));
    dispatch(setQuickQuoteRateValues(''));
    dispatch(setQuickQuotePickUpCheckedRedux(false));
    dispatch(setQuickQuoteDeliveryCheckedRedux(false));
    dispatch(setClassWeight(''));
    dispatch(setDimensionsWeight(''));
    history.push('/agency-signin');
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <NotificationDialog
        notifView={notifView}
        isOpen={dialogOpen}
        handleClose={() => setDialogOpen(false)}
      />

      {/* Notifications */}
      <Dropdown
        isOpen={notifOpen}
        toggle={() => setNotifOpen(p => !p)}
        className='list-inline-item'
      >
        <DropdownToggle tag='a' id='notifficationdropdown' type='button'>
          <Badge badgeContent={UserNotificationsObj?.count} color='primary'>
            <NotificationsIcon
              sx={{ fontSize: 24, color: 'rgb(25, 118, 210)', mt: '2px' }}
            />
          </Badge>
        </DropdownToggle>
        <DropdownMenu
          end
          style={{
            width: 380,
            maxHeight: 500,
            overflowY: 'auto',
            padding: '12px 16px'
          }}
        >
          <div
            style={{
              marginBottom: 12,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography>
              Notifications ({UserNotificationsObj?.count || 0})
            </Typography>
          </div>
          {UserNotifications.length === 0 ? (
            <div style={{ padding: '24px 0', textAlign: 'center' }}>
              <Typography>No new notifications</Typography>
            </div>
          ) : (
            <div style={{ marginBottom: 12 }}>
              {UserNotifications.map(n => (
                <NotificationCard
                  key={n.id}
                  id={n.id}
                  title={n.title}
                  description={sanitizeHTML(n.message)}
                  time={formatNotificationTime(n.receivedOn)}
                  status={!n.isRead}
                  setGlobalOpen={setDialogOpen}
                  setGlobalNotification={setNotifView}
                />
              ))}
            </div>
          )}
          <div
            style={{
              borderTop: '1px solid #e9ecef',
              paddingTop: 12,
              marginTop: 4,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Link
              to='/notifications'
              style={{
                fontSize: 13,
                textDecoration: 'underline',
                color: '#1976d2'
              }}
            >
              View All
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>

      {/* User profile */}
      <Dropdown
        isOpen={userProfileOpen}
        toggle={() => setUserProfileOpen(p => !p)}
        className='list-inline-item'
      >
        <DropdownToggle tag='a' id='userdropdown' type='button' style={{ cursor: 'pointer' }}>
          {AgencyAdminDetails?.userAvatar ? (
            <img src={base_logo_url + AgencyAdminDetails.userAvatar} alt='avatar'
              style={{ ...avatarStyle, borderRadius: '50%' }} />
          ) : (
            <Box sx={{
              width: 36, height: 36, borderRadius: '50%',
              bgcolor: '#3361FF', color: 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 700, flexShrink: 0
            }}>
              {firstLetter}{lastLetter}
            </Box>
          )}
        </DropdownToggle>
        <DropdownMenu end style={{ minWidth: 160 }}>
          <li>
            <Link className='dropdown-item' to='/user-profile'>
              My Profile
            </Link>
          </li>
          <li>
            <button
              className='dropdown-item'
              onClick={handleLogout}
              style={{
                background: 'none',
                border: 'none',
                width: '100%',
                textAlign: 'left',
                cursor: 'pointer'
              }}
            >
              Logout
            </button>
          </li>
        </DropdownMenu>
      </Dropdown>
    </Box>
  );
};

// ─── Sidebar + AppBar layout (replaces Toolpad Core) ─────────────────────────
const AppLayout = ({ children, navigation }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [themeMode] = useState('light');
  const isMobile = useMediaQuery('(max-width:899px)');
  const [navTrackRef, setNavTrackRef] = useState('');
  const [trackDialogOpen, setTrackDialogOpen] = useState(false);
  const [trackDialogRef, setTrackDialogRef] = useState('');
  const [trackDialogKey, setTrackDialogKey] = useState(0);
  const [mobileTrackOpen, setMobileTrackOpen] = useState(false);
  const [mobileTrackInput, setMobileTrackInput] = useState('');
  const [navbarSlot, setNavbarSlot] = useState(null);

  const isShipmentsRoute = location.pathname === '/manage-shipments';

  const handleNavTrack = () => {
    const ref = navTrackRef.trim();
    if (ref) {
      setTrackDialogRef(ref);
      setTrackDialogKey(k => k + 1);
      setTrackDialogOpen(true);
      setNavTrackRef('');
    }
  };

  const handleMobileTrack = () => {
    const ref = mobileTrackInput.trim();
    if (ref) {
      setMobileTrackOpen(false);
      setMobileTrackInput('');
      setTrackDialogRef(ref);
      setTrackDialogKey(k => k + 1);
      setTrackDialogOpen(true);
    }
  };

  const muiTheme = useMemo(
    () => createTheme({ palette: { mode: themeMode } }),
    [themeMode]
  );

  const pageTitle = useMemo(() => {
    const match = navigation.find(item =>
      isActive(item.segment, location.pathname)
    );
    return match ? match.title : '';
  }, [navigation, location.pathname]);

  const isDark = themeMode === 'dark';

  const renderNavItems = expanded => {
    let lastSection = null;
    return navigation.map(item => {
      const active = isActive(item.segment, location.pathname);
      const showSectionLabel = expanded && item.section && item.section !== lastSection;
      if (item.section) lastSection = item.section;
      return (
        <React.Fragment key={item.segment}>
          {showSectionLabel && (
            <Typography sx={{
              fontSize: '10px', fontWeight: 600, letterSpacing: '0.8px',
              color: '#9CA3AF', textTransform: 'uppercase',
              px: 2, mt: 3, mb: 0.5
            }}>
              {item.section}
            </Typography>
          )}
          <ListItem disablePadding sx={{ display: 'block', mb: '2px' }}>
            <ListItemButton
              component={Link}
              to={'/' + item.segment}
              onClick={() => isMobile && setMobileOpen(false)}
              sx={{
                minHeight: expanded ? 40 : 56,
                flexDirection: expanded ? 'row' : 'column',
                justifyContent: 'center',
                alignItems: 'center',
                px: expanded ? 1.5 : 0.5,
                py: expanded ? 0.75 : 0.5,
                mx: '6px',
                borderRadius: '8px',
                borderLeft: active && expanded ? '3px solid #3361FF' : '3px solid transparent',
                bgcolor: active ? '#EEF2FF' : 'transparent',
                color: active ? '#3361FF' : '#4B5563',
                '&:hover': { bgcolor: active ? '#EEF2FF' : '#F3F4F6', color: active ? '#3361FF' : '#111827' }
              }}
            >
              <ListItemIcon sx={{
                minWidth: 0,
                mr: expanded ? 1.5 : 0,
                mb: expanded ? 0 : 0.3,
                justifyContent: 'center',
                color: 'inherit'
              }}>
                {item.icon}
              </ListItemIcon>
              {expanded ? (
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: active ? 600 : 500, whiteSpace: 'nowrap', color: 'inherit' }}
                />
              ) : (
                <Typography sx={{ fontSize: '0.6rem', fontWeight: active ? 600 : 400, color: 'inherit', textAlign: 'center', lineHeight: 1.2 }}>
                  {item.shortTitle || item.title}
                </Typography>
              )}
            </ListItemButton>
          </ListItem>
        </React.Fragment>
      );
    });
  };

  const navListSx = {
    pt: 1,
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none'
  };

  return (
    <NavbarSlotContext.Provider
      value={{ slot: navbarSlot, setSlot: setNavbarSlot }}
    >
      <ThemeProvider theme={muiTheme}>
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', bgcolor: 'background.default' }}>

          {/* ── Sidebar (full height) ── */}
          <Box
            component='nav'
            sx={{
              width: { xs: 0, md: sidebarOpen ? DRAWER_WIDTH : COLLAPSED_WIDTH },
              flexShrink: 0,
              transition: 'width 0.22s ease'
            }}
          >
            {/* Mobile: temporary overlay */}
            <Drawer
              variant='temporary'
              open={mobileOpen}
              onClose={() => setMobileOpen(false)}
              ModalProps={{ keepMounted: true }}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': {
                  width: DRAWER_WIDTH, boxSizing: 'border-box',
                  bgcolor: 'background.paper', borderRight: '1px solid',
                  borderColor: 'divider', display: 'flex', flexDirection: 'column'
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', px: 2, minHeight: 64, borderBottom: '1px solid', borderColor: 'divider', flexShrink: 0 }}>
                <AppLogo />
              </Box>
              <List sx={navListSx}>{renderNavItems(true)}</List>
            </Drawer>

            {/* Desktop: permanent full-height */}
            <Drawer
              variant='permanent'
              open
              sx={{
                display: { xs: 'none', md: 'block' },
                '& .MuiDrawer-paper': {
                  width: sidebarOpen ? DRAWER_WIDTH : COLLAPSED_WIDTH,
                  overflowX: 'hidden',
                  transition: 'width 0.22s ease',
                  bgcolor: 'background.paper',
                  borderRight: '1px solid',
                  borderColor: 'divider',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100vh',
                  top: 0
                }
              }}
            >
              {/* Sidebar header: logo + collapse toggle */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: sidebarOpen ? 'space-between' : 'center',
                  px: sidebarOpen ? 1.5 : 0,
                  minHeight: 64,
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  flexShrink: 0,
                  overflow: 'hidden'
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                  {sidebarOpen ? <AppLogo /> : <AppLogoIcon />}
                </Box>
                {sidebarOpen && (
                  <IconButton
                    size='small'
                    onClick={() => setSidebarOpen(false)}
                    sx={{
                      flexShrink: 0,
                      width: 28,
                      height: 28,
                      borderRadius: '8px',
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'background.paper',
                      color: 'text.secondary',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      '&:hover': { bgcolor: '#F3F4F6' }
                    }}
                  >
                    <KeyboardDoubleArrowLeftIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                )}
              </Box>
              <List sx={navListSx}>{renderNavItems(sidebarOpen)}</List>
            </Drawer>
          </Box>

          {/* ── Right column: AppBar + Content ── */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', minWidth: 0 }}>

          {/* ── AppBar ── */}
          <AppBar
            position='static'
            elevation={0}
            sx={{
              zIndex: 100,
              bgcolor: isDark ? 'background.paper' : '#F7F8FA',
              borderBottom: '1px solid',
              borderColor: 'divider',
              color: 'text.primary',
              flexShrink: 0
            }}
          >
            <Toolbar sx={{ minHeight: '64px !important', px: { xs: 1, sm: 2 }, gap: 1 }}>
              {/* Mobile: hamburger | Desktop: expand button when collapsed */}
              {isMobile ? (
                <IconButton size='small' sx={{ color: 'text.secondary', mr: 0.5 }} onClick={() => setMobileOpen(true)}>
                  <MenuIcon />
                </IconButton>
              ) : !sidebarOpen && (
                <IconButton
                  size='small'
                  onClick={() => setSidebarOpen(true)}
                  sx={{
                    mr: 0.5,
                    width: 28,
                    height: 28,
                    borderRadius: '8px',
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    color: 'text.secondary',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    '&:hover': { bgcolor: '#F3F4F6' }
                  }}
                >
                  <KeyboardDoubleArrowRightIcon sx={{ fontSize: 16 }} />
                </IconButton>
              )}

              {/* Divider + page title */}
              {pageTitle && (
                <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', flexShrink: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'text.primary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {pageTitle}
                  </Typography>
                </Box>
              )}

              {/* Spacer pushes everything below to the right */}
              <Box sx={{ flexGrow: 1 }} />

              {/* Track shipment search / shipments slot — right side */}
              {isShipmentsRoute ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                  {navbarSlot}
                </Box>
              ) : (
                <>
                  <IconButton
                    onClick={() => setMobileTrackOpen(true)}
                    sx={{ display: { xs: 'flex', sm: 'none' }, color: 'text.primary' }}
                    size='small'
                  >
                    <LocalShippingOutlinedIcon fontSize='small' />
                  </IconButton>
                  <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 0.5 }}>
                    <TextField
                      size='small'
                      variant='outlined'
                      placeholder='Track shipment…'
                      value={navTrackRef}
                      onChange={e => setNavTrackRef(e.target.value)}
                      onKeyPress={e => e.key === 'Enter' && handleNavTrack()}
                      sx={{ width: { sm: 160, md: 240, lg: 280 } }}
                      InputProps={{
                        sx: { height: 34, fontSize: 13, bgcolor: 'white', '& fieldset': { borderColor: 'rgba(0,0,0,0.18)' } }
                      }}
                    />
                    <Button
                      variant='contained'
                      size='small'
                      onClick={handleNavTrack}
                      sx={{ height: 34, textTransform: 'none', whiteSpace: 'nowrap', fontSize: 13 }}
                    >
                      Track
                    </Button>
                  </Box>
                </>
              )}

              <ToolbarActions />
            </Toolbar>
          </AppBar>

          {/* ── Content ── */}
          <Box
            sx={{ display: 'flex', flex: 1, overflow: 'hidden', minHeight: 0 }}
          >
            {/* REMOVED old sidebar block — sidebar is now outside this column */}
            <Box
              component='nav'
              sx={{
                width: 0,
                flexShrink: 0
              }}
            >
              {/* Mobile: temporary overlay */}
              <Drawer
                variant='temporary'
                open={false}
                onClose={() => {}}
                ModalProps={{ keepMounted: true }}
                sx={{
                  display: 'none',
                  '& .MuiDrawer-paper': {
                    width: DRAWER_WIDTH,
                    boxSizing: 'border-box',
                    bgcolor: 'background.paper',
                    borderRight: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    flexDirection: 'column'
                  }
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 2,
                    minHeight: 64,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    flexShrink: 0
                  }}
                >
                  <AppLogo />
                </Box>
                <List sx={navListSx}>{renderNavItems(true)}</List>
              </Drawer>

              {/* Desktop: permanent */}
              <Drawer
                variant='permanent'
                open
                sx={{
                  display: { xs: 'none', md: 'block' },
                  '& .MuiDrawer-paper': {
                    width: 0,
                    display: 'none'
                  }
                }}
              >
                <List sx={navListSx} />
              </Drawer>
            </Box>

            {/* Content */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                minWidth: 0,
                maxWidth: '100%',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
                bgcolor: isDark ? 'background.default' : '#F5F5F5'
              }}
            >
              {children}
            </Box>
          </Box>
          </Box>{/* end right column */}
        </Box>{/* end outer row */}

        {/* Track Shipment dialog — opens from navbar search, no page navigation */}
        <Dialog
          open={trackDialogOpen}
          onClose={() => setTrackDialogOpen(false)}
          maxWidth='xl'
          fullWidth
          PaperProps={{ sx: { height: '85vh' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 1.5,
              px: 2,
              borderBottom: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography fontWeight={600}>
              Track Shipment — {trackDialogRef}
            </Typography>
            <IconButton size='small' onClick={() => setTrackDialogOpen(false)}>
              <CloseIcon fontSize='small' />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 1, overflow: 'auto' }}>
            <TrackShipmentModule
              key={trackDialogKey}
              searchRef={trackDialogRef}
            />
          </DialogContent>
        </Dialog>
        {/* Mobile track input dialog */}
        <Dialog
          open={mobileTrackOpen}
          onClose={() => setMobileTrackOpen(false)}
          fullWidth
          maxWidth='xs'
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 1.5,
              px: 2,
              borderBottom: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography fontWeight={600}>Track Shipment</Typography>
            <IconButton size='small' onClick={() => setMobileTrackOpen(false)}>
              <CloseIcon fontSize='small' />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: '16px !important', pb: 2, px: 2 }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                autoFocus
                fullWidth
                size='small'
                variant='outlined'
                placeholder='Enter tracking number…'
                value={mobileTrackInput}
                onChange={e => setMobileTrackInput(e.target.value)}
                onKeyPress={e => e.key === 'Enter' && handleMobileTrack()}
                InputProps={{ sx: { bgcolor: 'white' } }}
              />
              <Button
                variant='contained'
                size='small'
                onClick={handleMobileTrack}
                sx={{ whiteSpace: 'nowrap', height: 40, textTransform: 'none' }}
              >
                Track
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </NavbarSlotContext.Provider>
  );
};

// ─── Main Layout ──────────────────────────────────────────────────────────────
const Layout = props => {
  const location = useLocation();
  const history = useHistory();
  const CurrentRoute = location.pathname;
  const selectedModuleName = localStorage.getItem('selectedModulePersist');

  const dispatch = useDispatch();
  const rememberMe = useSelector(state => state.userDetails.rememberMe);
  const [userRolePermissionsArray, setUserRolePermissionsArray] =
    useState(null);

  const UserId = sessionStorage.getItem('UserAuthToken');
  const tokenExpiry = localStorage.getItem('tokenExpiryTime');
  const tokenExpiryTime = new Date(tokenExpiry);
  const currentTime = new Date();

  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const [routesArray, setRoutesArray] = useState(null);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  // ── Build permission arrays ───────────────────────────────────────────────
  useEffect(() => {
    const updatedArray = new Set();
    const routes = new Set();
    userRolePermissions?.forEach(permission => {
      const allLevelsTrue =
        !permission.level1 &&
        !permission.level2 &&
        !permission.level3 &&
        !permission.level4 &&
        !permission.level5;
      const dashboardAllLevelsTrue =
        allLevelsTrue &&
        !permission.level6 &&
        !permission.level7 &&
        !permission.level8 &&
        !permission.level9 &&
        !permission.level10;

      if (!dashboardAllLevelsTrue) {
        updatedArray.add(permission.permissionName);
        if (permission.permissionName.includes('Dashboard'))
          routes.add('/dashboard');
      }
      if (!allLevelsTrue) {
        updatedArray.add(permission.permissionName);
        if (permission.permissionName.includes('Quick')) {
          routes.add('/quick-quote');
          routes.add('/bookshipment');
          routes.add('/bookshipmentTL');
        }
        if (permission.permissionName.includes('Carriers')) {
          routes.add('/carriers');
          routes.add('/create-carrier');
        }
        if (permission.permissionName.includes('Users')) routes.add('/users');
        if (permission.permissionName.includes('Roles')) routes.add('/roles');
        if (permission.permissionName === 'Manage-Shipments') {
          routes.add('/manage-shipments');
          routes.add('/dispatchshipmentLTL');
          routes.add('/bookshipmentTL');
          routes.add('/dispatchshipmentParcel');
          routes.add('/dispatchshipmentTL');
        }
        if (permission.permissionName.includes('Locations')) {
          routes.add('/view-locations');
          routes.add('/add-locations');
        }
        if (permission.permissionName.includes('Settings'))
          routes.add('/settings');
        if (permission.permissionName.includes('App-Registration'))
          routes.add('/app-registration');
        if (permission.permissionName.includes('Invoice-Audit'))
          routes.add('/invoice-audit');
        if (permission.permissionName === 'Track-Shipments')
          routes.add('/track-shipment');
        if (permission.permissionName.includes('Logs')) routes.add('/Logs');
        routes.add('/user-profile');
        routes.add('/notifications');
        routes.add('/user-dashboard');
        routes.add('/new-dashboard');
        routes.add('/claims-dashboard');
        routes.add('/');
      }
    });
    setUserRolePermissionsArray(Array.from(updatedArray));
    setRoutesArray(Array.from(routes));
  }, [userRolePermissions]);

  // ── Cookie / session guard ────────────────────────────────────────────────
  const handleResetLocalStorage = () => {
    !rememberMe && dispatch(setPasswordRedux(''));
    !rememberMe && dispatch(setEmailRedux(''));
    !rememberMe && dispatch(setUserDetailsObj({}));
    localStorage.clear();
    history.push('/agency-signin', 'sessionExpired');
  };

  useEffect(() => {
    const getCookieValue = name => {
      const cookies = document.cookie.split('; ');
      for (let i = 0; i < cookies.length; i++) {
        const c = cookies[i].split('=');
        if (c[0] === name) return c[1];
      }
      return null;
    };
    if (getCookieValue('userInfo') === null) handleResetLocalStorage();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Token expiry redirect ─────────────────────────────────────────────────
  setTimeout(() => {
    if (tokenExpiryTime - currentTime <= 0) {
      window.location.href = '/agency-signin';
      localStorage.clear();
      localStorage.setItem('CurrentRoute', CurrentRoute);
      !rememberMe && dispatch(setPasswordRedux(''));
      !rememberMe && dispatch(setEmailRedux(''));
      dispatch(setUserToken(''));
      dispatch(setLoginAgencyID(''));
      dispatch(setRateValues(''));
      dispatch(setQuickQuoteTLRateValues(''));
      dispatch(setQuickQuoteRateValues(''));
    }
  }, tokenExpiryTime - currentTime);

  // ── Idle timer ────────────────────────────────────────────────────────────
  useIdleTimer({
    onIdle: () => {
      if (UserId) {
        history.push('/agency-locked-screen', {
          currentRoute: CurrentRoute,
          selectedModuleName
        });
      }
    },
    onActive: () => {},
    onAction: () => {},
    timeout: 3600000,
    throttle: 500
  });

  // ── Route access guard ────────────────────────────────────────────────────
  useEffect(() => {
    if (!routesArray) return;
    const modulesURLs = [
      '/quick-quote',
      '/bookshipment',
      '/dispatchshipmentLTL',
      '/bookshipmentTL',
      '/dispatchshipmentTL',
      '/bookshipmentParcel',
      '/dispatchshipmentParcel',
      '/dashboard',
      '/user-dashboard',
      '/new-dashboard',
      '/claims-dashboard',
      '/carriers',
      '/create-carrier',
      '/users',
      '/roles',
      '/manage-shipments',
      '/view-locations',
      '/add-locations',
      '/app-registration',
      '/track-shipment',
      '/Logs',
      '/dispatch',
      '/settings',
      '/user-profile',
      '/not-assigned',
      '/invoice-audit',
      '/notifications',
      '/'
    ];
    const currentPath = location.pathname;
    if (!modulesURLs.includes(currentPath)) history.push('/404');
    if (routesArray && !UserIsAdmin && UserId) {
      if (currentPath === '/') {
        history.push(
          routesArray.includes('/manage-shipments')
            ? '/manage-shipments'
            : routesArray.includes('/quick-quote')
              ? '/quick-quote'
              : routesArray[0]
        );
      }
      if (
        modulesURLs.includes(currentPath) &&
        !routesArray.includes(currentPath)
      ) {
        localStorage.setItem('invalidUrl', currentPath);
        history.push('/not-assigned');
      }
    }
  }, [location.pathname, routesArray, UserIsAdmin, history]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Notifications polling ─────────────────────────────────────────────────
  const fetchAppNotifications = () => {
    GetAppNotifications(true, 5)
      .then(res =>
        dispatch(
          setUserAppNotifications({
            notifications: res?.data?.data,
            count: res?.data?.pagingInfo?.pageSize
          })
        )
      )
      .catch(() => {});
  };

  useEffect(() => {
    if (!UserId || UserId === '') return;
    fetchAppNotifications();
    const interval = setInterval(fetchAppNotifications, 300000);
    return () => clearInterval(interval);
  }, [UserId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Permission-filtered navigation ───────────────────────────────────────
  const filteredNavigation = useMemo(() => {
    if (UserIsAdmin) return FULL_NAVIGATION;
    if (!userRolePermissionsArray) return [];
    return FULL_NAVIGATION.filter(item => {
      const key = PERMISSION_MAP[item.segment];
      return key && userRolePermissionsArray.some(p => p.includes(key));
    });
  }, [UserIsAdmin, userRolePermissionsArray]);

  return (
    <React.Fragment>
      {UserId && UserId !== '' ? (
        <AppLayout navigation={filteredNavigation}>{props.children}</AppLayout>
      ) : (
        <SignIn />
      )}
    </React.Fragment>
  );
};

export default Layout;
